const saveBlobToUri = async (blob: Blob, ext: string): Promise<string | undefined> => {
	return undefined;
};
export default saveBlobToUri;
